const categoryList = [
  {
    type: "노래",
    eng: "music",
  },
  {
    type: "책",
    eng: "book",
  },
  {
    type: "영상",
    eng: "video",
  },
  {
    type: "음식",
    eng: "food",
  },
  {
    type: "소비",
    eng: "item",
  },
  {
    type: "공간",
    eng: "place",
  },
  {
    type: "운동",
    eng: "workout",
  },
  {
    type: "순간",
    eng: "moment",
  },
];

export default categoryList;
